export const monthNamesByLanguage: { [key: string]: { [key: number]: string } } = {
  is: {
    0: 'janúar',
    1: 'febrúar',
    2: 'mars',
    3: 'apríl',
    4: 'maí',
    5: 'júní',
    6: 'júlí',
    7: 'ágúst',
    8: 'september',
    9: 'október',
    10: 'nóvember',
    11: 'desember',
  },
};

const supportedLanguages = Object.keys(monthNamesByLanguage);

export function monthName(d: Date, language = 'is'): string {
  const monthNumber = d.getMonth();
  const lowerdLangage = language.toLocaleLowerCase();

  // Check if we have a fixture for the applied language
  if (!Object.keys(monthNamesByLanguage).includes(lowerdLangage)) {
    throw new Error(`applied language is not supported: ${language}. Supported: ${supportedLanguages}`);
  }

  return monthNamesByLanguage[lowerdLangage][monthNumber];
}

export function formatIcelandicDate(dateStr: string): string {
  const date = new Date(dateStr);

  const months = [
    'janúar',
    'febrúar',
    'mars',
    'apríl',
    'maí',
    'júní',
    'júlí',
    'ágúst',
    'september',
    'október',
    'nóvember',
    'desember',
  ];

  if (isNaN(date.getTime())) {
    return '';
  }

  const day = date.getUTCDate();
  const month = months[date.getUTCMonth()];
  const year = date.getUTCFullYear();
  const hours = String(date.getUTCHours()).padStart(2, '0');
  const minutes = String(date.getUTCMinutes()).padStart(2, '0');

  return `${day}. ${month} ${year} ${hours}:${minutes}`;
}
